<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">keyboard</span>
      <h2>Raccourcis &amp; Astuces</h2>
    </div>

    <p class="section-intro">
      Gagnez du temps avec ces raccourcis et bonnes pratiques pour une utilisation optimale de ComptaMiton.
    </p>

    <!-- ===== NAVIGATION ===== -->
    <h3 class="sub-title">Navigation rapide</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Action</th><th>Comment faire</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Retour au tableau de bord</strong></td><td>Cliquez sur l'icône <span class="material-icons-sharp" style="font-size:14px;vertical-align:middle">home</span> dans la barre supérieure.</td></tr>
          <tr><td><strong>Changer de module</strong></td><td>Utilisez le menu latéral gauche. Cliquez sur le nom du module souhaité.</td></tr>
          <tr><td><strong>Ouvrir la documentation</strong></td><td>Cliquez sur le lien <strong>Documentation</strong> dans le menu latéral.</td></tr>
          <tr><td><strong>Rechercher dans un tableau</strong></td><td>Utilisez la barre de recherche en haut du tableau. Tapez au moins 2 caractères.</td></tr>
          <tr><td><strong>Trier un tableau</strong></td><td>Cliquez sur l'en-tête de colonne pour trier par ordre croissant/décroissant.</td></tr>
        </tbody>
      </table>
    </div>

    <!-- ===== FORMULAIRES ===== -->
    <h3 class="sub-title">Astuces pour les formulaires</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Astuce</th><th>Détails</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Champs obligatoires</strong></td><td>Repérés par un astérisque rouge <span style="color:#e53935">*</span>. Le bouton Soumettre reste grisé tant qu'un champ obligatoire est vide.</td></tr>
          <tr><td><strong>Listes déroulantes</strong></td><td>Commencez à taper pour filtrer les options. Plus vous tapez, plus la liste se réduit.</td></tr>
          <tr><td><strong>Champs désactivés</strong></td><td>Les champs grisés sont calculés automatiquement (prix, soldes, totaux). Vous ne pouvez pas les modifier.</td></tr>
          <tr><td><strong>Fichiers joints</strong></td><td>Cliquez sur le champ fichier pour ouvrir le sélecteur. Formats acceptés : PDF, JPG, PNG.</td></tr>
          <tr><td><strong>Dates</strong></td><td>Cliquez sur le champ date pour ouvrir le calendrier. Vous pouvez aussi taper la date au format JJ/MM/AAAA.</td></tr>
          <tr><td><strong>Annuler un formulaire</strong></td><td>Fermez la modale en cliquant sur la croix <span class="material-icons-sharp" style="font-size:14px;vertical-align:middle">close</span> ou en cliquant en dehors. Aucune donnée n'est enregistrée.</td></tr>
        </tbody>
      </table>
    </div>

    <!-- ===== BONNES PRATIQUES ===== -->
    <h3 class="sub-title">Bonnes pratiques</h3>
    <ul class="doc-list">
      <li><strong>Toujours remplir les observations :</strong> Même si le champ n'est pas obligatoire, les observations facilitent le suivi et les audits.</li>
      <li><strong>Joindre des justificatifs :</strong> Pour les inventaires, retours et demandes de sortie d'argent, joignez systématiquement un fichier preuve.</li>
      <li><strong>Vérifier avant de soumettre :</strong> Certaines actions sont irréversibles (envoi à la caisse, vidage de compte). Relisez les données avant de cliquer sur Soumettre.</li>
      <li><strong>Utiliser les filtres :</strong> Dans les modules Statistiques et les tableaux, les filtres réduisent le temps de recherche.</li>
      <li><strong>Déconnexion :</strong> Pensez à vous déconnecter en fin de session, surtout sur un poste partagé.</li>
    </ul>

    <div class="info-card tip">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#4caf50">lightbulb</span>
        Astuce clavier
      </div>
      <p>
        Dans les listes déroulantes, utilisez les touches <strong>↑ ↓</strong> pour naviguer et <strong>Entrée</strong> pour sélectionner.
        <strong>Tab</strong> passe au champ suivant, <strong>Shift+Tab</strong> au champ précédent.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocRaccourcis" };
</script>
